import React from 'react';
import { useFadeIn } from '../hooks/useAnimations';

const FadeInSection = ({ children, className = '' }) => {
  const { ref, visible } = useFadeIn(0.1);
  return (
    <div ref={ref} className={`animate-fade-up ${visible ? 'visible' : ''} ${className}`}>
      {children}
    </div>
  );
};

export default FadeInSection;
